module.exports = __webpack_public_path__ + "static/oea.7fd62d97.png";